import React from 'react'
import ConfirmPassForm from '../../Components/ForgetPass/ConfirmPassForm'

function ConfirmPass() {
  return (
    <div className='bg-signin-bg'>
    <div className='  grid w-10/12 md:w-8/12   mx-auto h-[100vh] place-items-center'>
      <ConfirmPassForm/>
    </div>
    </div>
  )
}

export default ConfirmPass